import "konva";
import Konva from "konva/lib";

var pieCharts = (function () {

	function setup() {
		$('div.pie-chart').each((i, e) => {
			let pieChart = new PieChart(e);
			pieChart.drawChart();

			let segments = $(e).parent().find('.segment-wrapper .segment');
			let images = $(e).closest('.block').find('.pie-images img');
			let svgIds = $(e).data('data').map(a => a.svgId);
			let clickedIndex = 0;

			if (svgIds != null && svgIds.length > 0) {
				// Add rollovers for the map svg
				for (var i = 0; i < svgIds.length; i++) {
					//$('#World_Map path').on('mouseover', function (evt) {
					//	let parent = $(this).parent().prop('id');
					//	let idx = svgIds.indexOf(parent);
					//	if (idx > -1) {
					//		segments.addClass('d-none');
					//		$(segments[idx]).removeClass('d-none');
					//		pieChart.activate(idx);
					//	}
					//});

					//$('#World_Map path').on('mouseout', function (evt) {
					//	segments.addClass('d-none');
					//	$(segments[pieChart.activeId]).removeClass('d-none');
					//	$('#World_Map g:not(#Land)').addClass('hide');
					//	$('#World_Map #' + svgIds[pieChart.activeId]).removeClass('hide');

					//	let parent = $(this).parent().prop('id');
					//	let idx = svgIds.indexOf(parent);
						
					//	if (idx > -1) {						
					//		pieChart.deActivate(idx, true);
					//	}
					//});

					$('#World_Map path').on('click', function (evt) {

						let parent = $(this).parent().prop('id');
						let idx = svgIds.indexOf(parent);

						$('#World_Map g:not(#Land)').addClass('hide');
						$('#World_Map #' + svgIds[idx]).removeClass('hide');

						if (idx > -1) {
							pieChart.activate(idx);
							pieChart.activeId = idx;
							segments.addClass('d-none');
							$(segments[idx]).removeClass('d-none');
						}
					});
				}
			}

			$(e).on('segment-over', function (evt, index) {
				segments.addClass('d-none');
				$(segments[index]).removeClass('d-none');

				images.addClass('d-none');
				$(images[index]).removeClass('d-none');

				if (svgIds != null && svgIds.length > 0) {
					$('#World_Map g:not(#Land)').addClass('hide');
					$('#World_Map #' + svgIds[index]).removeClass('hide');
				}
			});

			$(e).on('segment-out', function (evt, activeIndex) {
				segments.addClass('d-none');
				$(segments[activeIndex]).removeClass('d-none');

				images.addClass('d-none');
				$(images[activeIndex]).removeClass('d-none');

				if (svgIds != null && svgIds.length > 0) {
					$('#World_Map g:not(#Land)').addClass('hide');
				}

				activateSegment(pieChart.activeId);
			});

			$(e).on('segment-click', function (evt, activeIndex) {
				clickedIndex = activeIndex;
				pieChart.activeId = activeIndex;
				segments.addClass('d-none');
				activateSegment(clickedIndex);
			});

			function activateSegment(index) {
				$(segments[index]).removeClass('d-none');
				$(images[index]).removeClass('d-none');
				$('#World_Map #' + svgIds[index]).removeClass('hide');
			}

			$(window).on('resize', function () {

				let sd = $(pieChart.chart).data('dimension');
				let newSd = pieChart.getDimension();
				let scale = newSd / sd;

				pieChart.stage.width(newSd);
				pieChart.stage.height(newSd);
				pieChart.stage.scale({ x: scale, y: scale });

				$(pieChart.chart).data('dimension', sd);

			});

			segments.addClass('d-none');
			images.addClass('d-none');

			if (svgIds != null && svgIds.length > 0) {
				$('#World_Map g:not(#Land)').addClass('hide');
			}

			activateSegment(clickedIndex);
		});
	}

	return {
		init: function () {
			$(function () {
				setup();
			});
		}
	};
})();

export var pieCharts;

class PieChart {

	chart;
	stage;
	activeId = 0;
	items = [];

	constructor(chart) {
		this.chart = chart;
	}

	getDimension() {
		var sh = this.constrain($(this.chart).parent().outerHeight(), 300, 600);
		var sw = this.constrain($(this.chart).parent().outerWidth(), 400, 600);
		var sd = sw > sh ? sh : sw; // Use the smallest size as our dimension (we're always square)

		return sd;
	}

	drawChart() {

		let sd = this.getDimension(this.chart);
		$(this.chart).data('dimension', sd);

		var stage = new Konva.Stage({
			container: $(this.chart).prop('id'),
			width: sd,
			height: sd
		});

		var layer = new Konva.Layer();

		var w = stage.width(), h = stage.height(),
			sectorWidth = 25, offset = 30,
			labelRadius = 32;
		var data = $(this.chart).data('data');

		for (let s = 0; s < data.length; s++) {

			let arcBase = new Konva.Arc({
				x: w / 2,
				y: h / 2,
				innerRadius: w / 2 - sectorWidth - offset,
				outerRadius: w / 2 - offset,
				angle: data[s].end - data[s].start - 1,
				rotation: data[s].start - 90,
				fill: '#437AB2'
			});

			let activeGroup = new Konva.Group();

			let arcActive = new Konva.Arc({
				x: w / 2,
				y: h / 2,
				innerRadius: w / 2 - sectorWidth - offset,
				outerRadius: w / 2 - offset,
				angle: data[s].end - data[s].start - 1,
				rotation: data[s].start - 90,
				fill: '#F2646B'
			});
			activeGroup.add(arcActive);

			let midPoint = this.getMidPointXandY(data[s].end - data[s].start - 1, data[s].start - 90, w / 2 - offset - (sectorWidth / 2));
			let labelCircle = new Konva.Circle({
				x: w / 2 + midPoint.x,
				y: h / 2 + midPoint.y,
				radius: labelRadius,
				fill: '#F2646B',
				shadowColor: '#000000',
				shadowBlur: 10,
				shadowOpacity: 0.33,
				shadowOffset: { x: 0, y: 4 }
			});
			activeGroup.add(labelCircle);

			let labelText = new Konva.Text({
				x: w / 2 + midPoint.x,
				y: h / 2 + midPoint.y,
				text: data[s].pct,
				fill: '#ffffff',
				fontFamily: 'Open sans',
				fontSize: 22
			});
			labelText.offsetX(labelText.width() / 2);
			labelText.offsetY(labelText.height() / 2);

			activeGroup.add(labelText);

			if (s == this.activeId) {
				arcBase.hide(); activeGroup.show();
			} else {
				arcBase.show(); activeGroup.hide();
			}

			this.items[this.items.length] = { baseArc: arcBase, activeGroup: activeGroup };

			arcBase.on('mouseover', () => { stage.container().style.cursor = 'pointer'; })
				.on('click', () => { this.activate(s); stage.container().style.cursor = 'default'; });

			activeGroup.on('mouseover', () => { this.activate(s); stage.container().style.cursor = 'pointer'; })
				.on('mouseout', () => { stage.container().style.cursor = 'default'; })
				.on('click', () => { this.activeId = s; this.activate(s); $(this.chart).trigger('segment-click', this.activeId); });

			arcBase.on('tap', () => {
				this.items[this.activeId].baseArc.show();
				this.items[this.activeId].activeGroup.hide();
				$(this.chart).trigger('segment-out', s);
				$(this.chart).trigger('segment-click', s);

				this.activeId = s;
				this.items[s].baseArc.hide();
				this.items[s].activeGroup.show();
				
			});

			layer.add(activeGroup);
			layer.add(arcBase);

			this.stage = stage;
		}

		stage.add(layer);
		layer.draw();
	}

	activate(index) {

		this.items[index].baseArc.hide();
		this.items[index].activeGroup.show();

		// Hide all other
		this.items.forEach(function (a, i) {
			if (index != i) {
				a.baseArc.show();
				a.activeGroup.hide();
			}
		});

		$(this.chart).trigger('segment-over', index);
	}

	deActivate(index, cancelBubble = false) {

		//if (index == this.activeId) return;

		//this.items[index].baseArc.show();
		//this.items[index].activeGroup.hide();

		//if (this.activeId > -1) {
		//	this.items[this.activeId].baseArc.hide();
		//	this.items[this.activeId].activeGroup.show();
		//}

		//if (!cancelBubble) {
		//	$(this.chart).trigger('segment-out', this.activeId);
		//}
	}

	getMidPointXandY(angle, rotation, radius) {
		var x = Math.cos((rotation + angle / 2) * Math.PI / 180) * radius;
		var y = Math.sin((rotation + angle / 2) * Math.PI / 180) * radius;

		return { x, y };
	}

	constrain(val, min, max) {
		if (val >= min && val <= max) return val;
		if (val < min) return min;
		if (val > max) return max;
	}
}